/* eslint-disable prefer-destructuring */
import ConsultationRichInput from '@brands/Components/Inputs/RichTextField/RichTextField';
import React, { SetStateAction } from 'react';
import { FieldErrors, UseFormGetValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import { ICase } from '../../../../services/cases/types/ICase';
import { UserProfile } from '../../../../services/identity/types/UserProfile';
import { updateOneReport } from '../../../../services/oneReport/updateOneReport';
import { checkCollapsibleHeaderColor } from '../../../../Utils/getCollapsibleHeader';
import { OralHealthReportSubmit } from '../../assets/types';
import styles from '../../styles.module.scss';

type AssessmentSectionProps = {
  consultationForm: OralHealthReportSubmit;
  setConsultationForm: React.Dispatch<React.SetStateAction<OralHealthReportSubmit>>;
  thisCase: ICase;
  setCase: React.Dispatch<SetStateAction<ICase>>;
  userInfo: UserProfile;
  register: UseFormRegister<OralHealthReportSubmit>;
  setValue: UseFormSetValue<OralHealthReportSubmit>;
  getValues: UseFormGetValues<OralHealthReportSubmit>;
  errors: FieldErrors<OralHealthReportSubmit>;
};

const AssessmentSection = ({
  consultationForm,
  setConsultationForm,
  thisCase,
  setCase,
  userInfo,
  register,
  setValue,
  getValues,
  errors,
}: AssessmentSectionProps): JSX.Element => {
  const saveCaseAssessment = async (caseAssessment: string): Promise<void> => {
    const { assessments: res } = await updateOneReport(
      thisCase?.one_report.id || '',
      {
        assessments: caseAssessment,
      },
      userInfo.role.name,
    );
    setCase({
      ...thisCase,
      one_report: {
        ...thisCase.one_report,
        assessments: res,
      },
    });
  };

  const assessmentError = typeof errors.assessment?.message === 'string' ? errors.assessment.message : '';
  const hasAssessmentError = Boolean(assessmentError);

  return (
    <div className={styles.assessmentDiv}>
      <span className={styles.subjectiveTitle}>Assessment</span>
      <div className={styles.assessment}>
        <span className={`fs-unmask ${styles.assessmentSpan}`}>
          Clinical analysis
          <span className={`${styles.cDTDivSpanRequired} fs-unmask`}>*</span>
        </span>
        <ConsultationRichInput
          value={consultationForm.assessment}
          editable={
            checkCollapsibleHeaderColor(thisCase || '', userInfo, 'Assessment') === 'edit' ||
            checkCollapsibleHeaderColor(thisCase || '', userInfo, 'Assessment') === 'editNotRequired'
          }
          onChange={(html) => {
            setConsultationForm((prev) => ({
              ...prev,
              assessment: html,
            }));
            setValue('assessment', html, {
              shouldValidate: true,
              shouldDirty: true,
              shouldTouch: true,
            });
          }}
          onBlurSave={async (html) => saveCaseAssessment(html as string)}
          registerRef={(ref) => register('assessment').ref(ref)}
          error={hasAssessmentError}
          placeholder="Add assessment here"
          className={`fs-exclude ${styles.assessmentInput} ${styles.subjectiveInput}`}
          style={{ color: hasAssessmentError ? '#BA271A' : '' }}
        />
        {hasAssessmentError && <div className={styles.sectionErrorText}>{assessmentError}</div>}
      </div>
    </div>
  );
};

export default React.memo(AssessmentSection);
